import "../css/LoadingSpinner.css";
import {
  faCircleExclamation,
  faUserShield,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

const LoadingSpinner = ({
  height = "75vh",
  width = "100%",
  showText = true,
  spinner = "box-loader",
  message = "Loading...",
  style = {},
}) => {
  const currentStyle = { ...style, height: height, width };
  if (spinner === "box-loader") {
    return (
      <>
        <div className="spinner-container" style={currentStyle}>
          <div style={{ marginBottom: "80px" }}>
            {showText && <h1>{message}</h1>}
          </div>
          <div className="boxes">
            <div className="box">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <div className="box">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <div className="box">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <div className="box">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="spinner-container" style={currentStyle}>
      {spinner === "error" || spinner === "no-permission" ? (
        <FontAwesomeIcon
          size="4x"
          style={spinner === "error" ? { color: "red" } : { color: "#FFBF00" }}
          fade
          icon={spinner === "error" ? faCircleExclamation : faUserShield}
        />
      ) : (
        <div className={spinner}></div>
      )}
      {showText && <h1>{message}</h1>}
    </div>
  );
};

export default LoadingSpinner;
